export default {
  getStatuses: (data = null) => $nuxt.$axios.get($nuxt.$api.host + '/cases-status', data),
  create: (data = null) => $nuxt.$axios.post($nuxt.$api.host + '/cases-status', data),
  update: (status_uuid, data = null) => $nuxt.$axios.put($nuxt.$api.host + '/cases-status/' + status_uuid, data),
  delete: (status_uuid) => $nuxt.$axios.delete($nuxt.$api.host + '/cases-status/' + status_uuid),
}
